<div class="konami-modal">
  <h2 mat-dialog-title>Service Menu</h2>
  
  <mat-dialog-content>
    <div class="content">
      <div class="emoji-display">🔧</div>
      <p>This menu is for troubleshooting and debugging purposes.</p>
      <p>If you expected an easter egg, you're in the wrong place.</p>
      
      <mat-form-field>
          <mat-label>Service Code</mat-label>
          <input matInput [(ngModel)]="konamiService.serviceSelected">
        </mat-form-field>
    </div>

  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button (click)="closeDialog()">Close</button>
  </mat-dialog-actions>
</div>
